import React, { useEffect, useState } from "react";

//constants
import {
  DELEGATION_MANAGEMENT_STEP_1_FORM_FILTER,
  IDelegationManagementStepOneProps,
  TypeFilter,
} from "./module/constants";
import { DELEGATION_MANAGEMENT_URLS } from "../module/constants";

//components
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import { FormattedMessage } from "react-intl";
import Panel from "../../../ui/Panel/Panel";
import Table from "../../../components/Table/Table";
import ConfirmModal from "../../../components/Modals/ConfirmModal/ConfirmModal";
import BasicDateModal from "../../../components/Modals/BasicDateModal/BasicDateModal";
import ResponseModal from "../../../components/Modals/ResponseModal/ResponseModal";
import FilterTable from "../../../components/FilterTable/FilterTable";

//utils
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import messages from "./module/messages";
import { filter, isEmpty } from "ramda";

//selectors and action
import {
  selectCallState,
  selectDelegations,
  selectDelegationsLoader,
} from "../module/selectors";
import {
  modifyDelegations,
  resetCallState,
  modifyDelegationRequest,
  deleteDelegationRequest,
  delegationRequest,
  resetDelegationState,
} from "../module/actions";

//styles
import classes from "./DelegationManagementStepOne.module.scss";
import { ROUTES } from "../../../module/constants";
import {
  ISectionType,
  ITableType,
} from "../../../common/TablesConfiguration/tcConstants";
import filterMessages from "../../../translations/filterMessages";
import { extractDateRange } from "../../../utils/utils";

const form = DELEGATION_MANAGEMENT_STEP_1_FORM_FILTER;

const DelegationManagementStepOne = (
  props: IDelegationManagementStepOneProps
) => {
  const {
    delegations,
    delegationsLoader,
    callState,
    resetCallState,
    delegationRequest,
    modifyDelegationRequest,
    deleteDelegationRequest,
    resetDelegationState,
    changeLocation,
  } = props;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [selectedRowItem, setSelectedRowItem] = useState<object>({});

  const [tableFilter, setTableFilter] = useState<any>([]);

  useEffect(() => {
    resetDelegationState();
    delegationRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit: any = (values: any = {}) => {
    const { advancedSearchFilter, allFilter = "", ...rest } = values;
    let valueFilter: any[] = [];
    if (values && isEmpty(values)) return setTableFilter([]);

    if (advancedSearchFilter) {
      if (!isEmpty(rest)) {
        Object.keys(rest).forEach((element: any) => {
          valueFilter.push({
            id: TypeFilter[element as keyof typeof TypeFilter],
            value: rest[element],
            operation: "AND",
          });
        });
      }
    } else {
      valueFilter = [
        { id: "delegated", value: allFilter, operation: "OR" },
        { id: "role", value: allFilter, operation: "OR" },
        { id: "begin_date", value: allFilter, operation: "OR" },
        { id: "end_date", value: allFilter, operation: "OR" },
      ];
    }

    const { startDate: beginStart, endDate: beginEnd } = extractDateRange(
      valueFilter,
      "begin_date"
    );
    const { startDate: endStart, endDate: endEnd } = extractDateRange(
      valueFilter,
      "end_date"
    );

    valueFilter = valueFilter.reduce((acc, filter) => {
      if (filter.id === "begin_date") {
        if (beginStart === null && beginEnd === null) {
          return acc;
        } else {
          acc.push({
            ...filter,
            value: [
              beginStart ? new Date(beginStart).toISOString() : null,
              beginEnd ? new Date(beginEnd).toISOString() : null,
            ],
          });
          return acc;
        }
      }

      if (filter.id === "end_date") {
        if (endStart === null && endEnd === null) {
          return acc;
        } else {
          acc.push({
            ...filter,
            value: [
              endStart ? new Date(endStart).toISOString() : null,
              endEnd ? new Date(endEnd).toISOString() : null,
            ],
          });
          return acc;
        }
      }

      acc.push(filter);
      return acc;
    }, [] as any[]);

    // console.log("valueFilter", valueFilter);
    // console.log("tableFilter", tableFilter);
    // console.log("delegations", delegations);
    setTableFilter(valueFilter);
  };

  const showModalDelete = (id: string) => {
    setSelectedRow(id);
    setShowDeleteModal(true);
  };

  const showModalModify = (id: string) => {
    setSelectedRow(id);

    const delegation: any | null =
      filter((el: any) => el.delegation_id === id, delegations).length > 0
        ? filter((el: any) => el.delegation_id === id, delegations)[0]
        : null;
    setSelectedRowItem(delegation);

    setShowModifyModal(true);
  };

  const removeDelegations = () => {
    setShowDeleteModal(false);
    setShowResponseModal(true);
    deleteDelegationRequest(selectedRow);
    setSelectedRow("");
    resetCallState();
  };

  const modalModifyDelegations = (selectedRow: string, finishDate: Date) => {
    modifyDelegationRequest(selectedRow, {
      newEndDate: finishDate.getTime(),
    });
    setShowModifyModal(false);
    setSelectedRow("");
    resetCallState();
  };

  return (
    <React.Fragment>
      <ConfirmModal
        show={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        onConfirm={() => removeDelegations()}
      />
      <BasicDateModal
        show={showModifyModal}
        selectedRow={selectedRow}
        onCloseModal={() => setShowModifyModal(false)}
        onConfirm={(selectedRow: any, value: any) =>
          modalModifyDelegations(selectedRow, value)
        }
        selectedRowItem={selectedRowItem}
      />
      <ResponseModal
        onClose={() => setShowResponseModal(false)}
        show={showResponseModal}
        state={callState}
      />
      <div className={classes["actionsTop"]}>
        <OutlinedButton onClick={() => changeLocation(ROUTES.WELCOME)}>
          <FormattedMessage {...messages.CTAExit} />
        </OutlinedButton>
      </div>
      <Panel
        title={<FormattedMessage {...messages.panelTitle} />}
        loader={delegationsLoader}
      >
        <>
          {delegations && delegations.length > 0 && (
            <>
              <FilterTable
                messages={{ ...filterMessages, ...messages }}
                formProps={form}
                onSubmitProps={(val: any) => onSubmit(val)}
                advancedFilter={true}
                isAccordion={true}
                sectionType={ISectionType.DELEGATIONS}
                tableType={ITableType.DELEGATES_TABLE}
                typeFilter={TypeFilter}
                simpleFilterFields={[
                  "delegated",
                  "role",
                  "begin_date",
                  "end_date",
                ]}
              />
              <Table
                filterProps={tableFilter}
                dataSource={delegations}
                rowsChangeable={true}
                areRowDeletable={true}
                onDeleteRow={(id: string) => showModalDelete(id)}
                areRowEditable={true}
                onEditRow={(id: string) => showModalModify(id)}
                tableName={"Delegations_list"}
                sectionType={ISectionType.DELEGATIONS}
                tableType={ITableType.DELEGATES_TABLE}
              />
            </>
          )}
          {delegations && delegations.length === 0 && (
            <div className={classes["no-delegations-text"]}>
              <FormattedMessage {...messages.emptyDelegations} />
            </div>
          )}
        </>
      </Panel>

      <div className={classes["btnClass"]}>
        <OutlinedButton
          onClick={() =>
            changeLocation(DELEGATION_MANAGEMENT_URLS.ADD_DELEGATION)
          }
        >
          <FormattedMessage {...messages.addNewDelegation} />
        </OutlinedButton>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    delegations: selectDelegations,
    delegationsLoader: selectDelegationsLoader,
    callState: selectCallState,
  });

const mapDispatchToProps: any = {
  delegationRequest: () => delegationRequest(),
  resetCallState: () => resetCallState(),
  modifyDelegations: (delegations: []) => modifyDelegations(delegations),
  modifyDelegationRequest: (id: string, modifyDate: {}) =>
    modifyDelegationRequest(id, modifyDate),
  deleteDelegationRequest: (id: string) => deleteDelegationRequest(id),
  resetDelegationState: () => resetDelegationState(),
  changeLocation: (url: string) => push(url),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(DelegationManagementStepOne);
